import { createSelector } from "reselect";
import { getters } from "SalesPortal/Settings";
import * as R from "ramda";

export const getEventDescriptionLeft = createSelector(
  getters.data,
  ({ description }) => 250 - R.length(description)
);
